import React, { lazy } from 'react';
import { FadeIn, Section } from './Section';
import { XIcon, CheckIcon } from 'lucide-react';
const rows = [{
  without: 'Cobrás lo que te ofrecen, no lo que valés',
  with: 'Definís tu precio y lo sostenés con confianza',
  imgWithout: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=160&h=160&fit=crop&q=70&auto=format',
  imgWith: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=160&h=160&fit=crop&q=70&auto=format',
  altWithout: 'Calculadora con presupuesto bajo',
  altWith: 'Dinero y crecimiento'
}, {
  without: 'Creencias limitantes frenando tu prosperidad',
  with: 'Mentalidad próspera activada desde adentro',
  imgWithout: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=160&h=160&fit=crop&q=70&auto=format',
  imgWith: 'https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=160&h=160&fit=crop&q=70&auto=format',
  altWithout: 'Mujer pensativa',
  altWith: 'Mujer iluminada al sol'
}, {
  without: 'Sin saber qué ofrecer ni cómo diferenciarte',
  with: 'Oferta clara y posicionamiento de alto valor',
  imgWithout: 'https://images.unsplash.com/photo-1456406644174-8ddd4cd52a06?w=160&h=160&fit=crop&q=70&auto=format',
  imgWith: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=160&h=160&fit=crop&q=70&auto=format',
  altWithout: 'Papeles desorganizados',
  altWith: 'Plan estratégico organizado'
}, {
  without: 'Dependencia económica de un sueldo o una pareja',
  with: 'Ingresos propios, constantes y predecibles',
  imgWithout: 'https://images.unsplash.com/photo-1565514020179-026b92b84bb6?w=160&h=160&fit=crop&q=70&auto=format',
  imgWith: 'https://images.unsplash.com/photo-1593510987185-1ec2256148a3?w=160&h=160&fit=crop&q=70&auto=format',
  altWithout: 'Billetera vacía',
  altWith: 'Mujer empoderada trabajando'
}, {
  without: 'Años de habilidad sin convertirla en dinero',
  with: 'Primera venta en menos de 30 días',
  imgWithout: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=160&h=160&fit=crop&q=70&auto=format',
  imgWith: 'https://images.unsplash.com/photo-1556742044-3c52d6e88c62?w=160&h=160&fit=crop&q=70&auto=format',
  altWithout: 'Calendario con tiempo perdido',
  altWith: 'Primera venta realizada'
}, {
  without: 'Vergüenza y culpa al hablar de dinero',
  with: 'Cobrás sin culpa, sin bajar el número',
  imgWithout: 'https://images.unsplash.com/photo-1573497019418-b400bb3ab074?w=160&h=160&fit=crop&q=70&auto=format',
  imgWith: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=160&h=160&fit=crop&q=70&auto=format',
  altWithout: 'Mujer cubriendo su rostro',
  altWith: 'Mujer segura sonriendo'
}, {
  without: 'Sin orden ni sistema financiero claro',
  with: 'Estructura y disciplina para crecer mes a mes',
  imgWithout: 'https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=160&h=160&fit=crop&q=70&auto=format',
  imgWith: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=160&h=160&fit=crop&q=70&auto=format',
  altWithout: 'Caos financiero',
  altWith: 'Sistema y planificación'
}, {
  without: 'Otro mes igual al anterior',
  with: 'El mes que todo empieza a cambiar',
  imgWithout: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=160&h=160&fit=crop&q=70&auto=format',
  imgWith: 'https://images.unsplash.com/photo-1531844251246-9a1bfaae09fc?w=160&h=160&fit=crop&q=70&auto=format',
  altWithout: 'Rutina estancada',
  altWith: 'Nuevo comienzo'
}];
export function Comparison() {
  return <Section bg="cream" data-id="element-41">
      <FadeIn className="text-center mb-10 md:mb-16" data-id="element-42">
        <h2 className="text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-gold mb-3 md:mb-4" data-id="element-43">
          La Realidad
        </h2>
        <p className="font-serif text-3xl md:text-5xl text-plum" data-id="element-44">
          ¿Cuánto cuesta <span className="italic text-gold" data-id="element-45">no</span> tenerlo?
        </p>
      </FadeIn>

      <div className="max-w-5xl mx-auto" data-id="element-46">
        <div className="grid grid-cols-2 gap-3 md:gap-8 mb-4 md:mb-6" data-id="element-47">
          <div className="text-center font-bold tracking-[0.2em] uppercase text-[10px] md:text-sm text-plum/40" data-id="element-48">
            Sin Mujer Expansiva
          </div>
          <div className="text-center font-bold tracking-[0.2em] uppercase text-[10px] md:text-sm text-gold" data-id="element-49">
            ✦ Con Mujer Expansiva
          </div>
        </div>

        <div className="space-y-2.5 md:space-y-3" data-id="element-50">
          {rows.map((row, i) => <FadeIn key={i} delay={i * 0.05} className="grid grid-cols-2 gap-3 md:gap-6" data-id="element-51">
              {/* Without */}
              <div className="bg-cream-dark/60 p-3 md:p-4 flex items-center gap-3 md:gap-4 rounded-sm" data-id="element-52">
                <div className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded overflow-hidden grayscale opacity-70" data-id="element-53">
                  <img src={row.imgWithout} alt={row.altWithout} width="64" height="64" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-54" />
                </div>
                <div className="flex items-start gap-1.5 flex-1 min-w-0" data-id="element-55">
                  <XIcon className="text-red-400/70 flex-shrink-0 mt-0.5" size={14} data-id="element-56" />
                  <span className="text-plum/65 text-[11px] md:text-sm leading-snug" data-id="element-57">
                    {row.without}
                  </span>
                </div>
              </div>

              {/* With */}
              <div className="bg-plum p-3 md:p-4 flex items-center gap-3 md:gap-4 rounded-sm shadow-lg shadow-plum/10 border border-gold/20" data-id="element-58">
                <div className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded overflow-hidden ring-1 ring-gold/40" data-id="element-59">
                  <img src={row.imgWith} alt={row.altWith} width="64" height="64" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-60" />
                </div>
                <div className="flex items-start gap-1.5 flex-1 min-w-0" data-id="element-61">
                  <CheckIcon className="text-gold flex-shrink-0 mt-0.5" size={14} data-id="element-62" />
                  <span className="text-cream text-[11px] md:text-sm leading-snug font-medium" data-id="element-63">
                    {row.with}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}